<div class="input-wrapper w-100">
  <i class="bi bi-search"></i>
  <input 
    placeholder="{{ 'placeholders.search' | translate }}" 
    class="form-control" 
    [(ngModel)]="inputSearch"
    type="text"
    (ngModelChange)="inputSearchUpdate.next($event)"
  />
</div>
